import lodash from 'lodash';
import { browserHistory } from 'react-router';

import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { userDefaultInstitutionIdSelector } from 'common/selectors';
import { mutateGraphQL } from 'common/util/query';
import { nodeWithArgs, toMutation } from 'common/util/queryHelper';
import { getStudyTeamChanges, getStudyMetadataChanges } from '../selectors/getStudyChanges';

export const SAVING_STUDY_STATE = 'SAVING_STUDY_STATE';
export const STUDY_STATE_SAVED = 'STUDY_STATE_SAVED';

/**
 * Compares existing study data with data entered in the workflow. 
 * If any changes are found, they a persisted.
 * @param {String} studyId 
 * @param {String} [nextLocation] Next URL to push user 
 */
export function updateDraft(studyId, nextLocation) {
    return async (dispatch, getState) => {
        const store = getState();

        const institutionId = userDefaultInstitutionIdSelector(store);

        studyId = studyId || lodash.get(store, 'study.originalFields.studyId', null);

        const originalName = lodash.get(store, 'study.originalFields.studyName', null);
        const newName = lodash.get(store, 'study.fields.studyName', null);

        // Cannot update studyTypeId
        const originalTypeId = lodash.get(store, 'study.originalFields.studyType.id');
        // const newTypeId = lodash.get(store, 'study.fields.studyType.id');

        const originalStageId = lodash.get(store, 'study.originalFields.studyStage.id', null);
        const newStageId = lodash.get(store, 'study.fields.studyStage.id', null);

        const {
            studyTeamMembersToAdd,
            studyTeamMembersToUpdate,
            studyTeamMembersToRemove
        } = getStudyTeamChanges(store);

        const {
            studyMetadataToAdd,
            studyMetadataToRemove
        } = getStudyMetadataChanges(store);


        if (
            (originalName === newName) &&
            (originalStageId === newStageId) &&
            // (originalTypeId === newTypeId) &&
            (lodash.isEmpty(studyTeamMembersToAdd)) &&
            (lodash.isEmpty(studyTeamMembersToUpdate)) &&
            (lodash.isEmpty(studyTeamMembersToRemove)) &&
            (lodash.isEmpty(studyMetadataToAdd)) &&
            (lodash.isEmpty(studyMetadataToRemove))
        ) {
            return browserHistory.push(nextLocation || '/studies');
        }

        dispatch(savingStudyStateAction());

        const updateDraft = nodeWithArgs('updateStudyDraftV2', {
            institutionId,
            studyId,
            name: newName,
            studyTypeId: originalTypeId,
            currentStageId: newStageId,
            studyTeamMembersToAdd,
            studyTeamMembersToUpdate,
            studyTeamMembersToRemove: studyTeamMembersToRemove.map((t) => { return t.id; }),
            studyMetadataToAdd,
            studyMetadataToRemove,
        }, [
            'id'
        ]);

        const response = await mutateGraphQL(toMutation(updateDraft));

        validateResolvedMutation(response, dispatch);

        dispatch(studyStateSavedAction());
        dispatch(addApplicationMessage('success', 'Changes made to draft study saved.'));

        return browserHistory.push(nextLocation || '/studies');
    };
}

function validateResolvedMutation(response, dispatch) {
    if (response && response.errors) {
        dispatch(addApplicationMessage('error', 'An error occurred when saving draft.'));
        return;
    }
}

export function savingStudyStateAction() {
    return {
        type: SAVING_STUDY_STATE,
    };
}

export function studyStateSavedAction() {
    return {
        type: STUDY_STATE_SAVED
    };
}
